import React,{useState  } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Steps, Panel, Placeholder, ButtonGroup, Button, DatePicker as DatePickers } from 'rsuite';
import moment from "moment/moment";
import axios from 'axios';
import { WorkshopListURL } from '../../../apis/urls';
import { DatePicker, message } from 'antd';

const WorkshopSessionCreate = () => {

    

  const {wid, sid} = useParams();

  const navigate = useNavigate();



  const [inputFields, setInputFields] = useState([
    {sessionName:'',startDate: '', endDate: '', startTime:'',endTime:''}
  ]);

  const [nameErr,setNameErr] = useState(false);
  const [sDateErr,setSDateErr] = useState(false);
  const [eDateErr,setEDateErr] = useState(false);
  const [sTimeErr,setSTimeErr] = useState(false);
  const [eTimeErr,setETimeErr] = useState(false);

  const [nameErrInd,setNameErrInd] = useState('');
  const [sDateErrInd,setSDateErrInd] = useState('');
  const [eDateErrInd,setEDateErrInd] = useState('');
  const [sTimeErrInd,setSTimeErrInd] = useState('');
  const [eTimeErrInd,setETimeErrInd] = useState('');


const handleAddFields = (index) => {
    const values = [...inputFields];
    values.push({sessionName:'',startDate:'', endDate:''});





    let error = false


    if(inputFields[index].sessionName === '' || inputFields[index].startDate=== '' || inputFields[index].endDate === '')
    {
        error = true
    }else{
        setInputFields(values);  
    }

    





    if(inputFields[index].sessionName === ''){
        setNameErr(true)
        setNameErrInd(index)
    }else{
        setNameErr(false)
    }

    if(inputFields[index].startDate === ''){
        setSDateErr(true)
        setSDateErrInd(index)
    }else{
        setSDateErr(false)
    }

    if(inputFields[index].endDate === ''){
        setEDateErr(true)
        setEDateErrInd(index)
    }else{
        setEDateErr(false)
    }



};


const handleSubmit = e => {
    e.preventDefault();
};


const handleInputChange = (index, event, name) => {

    const values = [...inputFields];


    console.log("event", inputFields)


    console.log("typeeee", moment(event).format('HH:mm'))

    if (name === "sessionName") {
        values[index].sessionName = event.target.value;
    }else if(name === "startDate"){
        values[index].startDate = event;
    }else if(name === "endDate"){
        values[index].endDate = event;
    }
    setInputFields(values);
};

const handleRemoveFields = index => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
};





    const WorkshopMultipleAdd = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        const data = {
            sessions:inputFields
        }

        let inLength = inputFields.length - 1


        if(inputFields[inLength].sessionName === ''){
            setNameErr(true)
            setNameErrInd(inLength)
        }else{
            setNameErr(false)
        }
    
        if(inputFields[inLength].startDate === ''){
            setSDateErr(true)
            setSDateErrInd(inLength)
        }else{
            setSDateErr(false)
        }
    
        if(inputFields[inLength].endDate === ''){
            setEDateErr(true)
            setEDateErrInd(inLength)
        }else{
            setEDateErr(false)
        }
    


        if(inputFields[inLength].sessionName === '' || inputFields[inLength].startDate=== '' || inputFields[inLength].endDate === '')
        {

        }else{
        
            const instance = axios.create({

                baseURL: WorkshopListURL+"/session/create/"+wid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
                        
            instance.post('',data).then((response) =>{

                message.success(inputFields.length === 1?'Session created successfully':'Sessions created successfully')

                navigate("/sessions/"+wid)

            }).catch((error) =>{

                console.log("123456", error)
            });

        }


    }







  return (

        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add Sessions</h2>
                        </div>
                        <div className="page-rightside-action-column">

                        <button onClick={() => handleAddFields(inputFields.length - 1)}  data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add Session</span></button>

                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/workshop">Conference Manager</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to={"/sessions/"+wid}>Sessions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Session</li>
                        </ol>
                    </nav>





                    <Panel header={`Add Session`}>




<div class="main">
<ul class="cards-session">

{inputFields.length === 0?
        <button
        style={{background:'#144A98', color:'#fff',  borderRadius:'10px', padding:'10px', width:'100%'}}
        // className="btn btn-link"
        type="button"
        onClick={() => handleAddFields(0)}
    >
        Add Attendees
    </button>:

inputFields.map((inputField, index) => (

    <li class="cards_item">
    <div class="card-session">

                <Panel className="public_label" header={`Session ` +(index+1)} style={{padding:'5px', paddingTop:'20px', paddingBottom:'20px'}}>
                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="cards formcard medium">
                        <div className="cards-body" >

                                <div className="form-group">
                                <div className="row">
                                    <div className="col-md-12"  style={{marginTop:'20px'}}>
                                    <label>Session Name</label>  
                                        <input 
                                        placeholder="Session Name" 
                                        className='form-control public_input'
                                        id="sessionName"
                                        name="sessionName"
                                        value={inputField.name}
                                        onChange={event => {handleInputChange(index, event, 'sessionName')}}/>
                                        {nameErr && nameErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter session name</p>:null}
                                    </div>
                                    <div className="col-md-12 sess-eve-date"  style={{marginTop:'20px'}}>
                                    <label>Start Date</label>  
                                        <DatePicker size="lg"
                                            defaultValue={inputFields[index].startDate ? moment(inputFields[index].startDate, 'MM-DD-YYYY HH:mm') : null}
                                            placeholder="End Date (MM-DD-YYYY)"
                                            showTime
                                            onChange={event => {handleInputChange(index, event, 'startDate')}} 
                                            className="start-date-picker" 
                                        />
                                        {sDateErr && sDateErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter start date</p>:null}
                                    </div> 

                                    <div className="col-md-12 sess-eve-date"  style={{marginTop:'20px'}}>
                                    <label>End Date</label>  
                                        <DatePicker  size="lg"
                                            defaultValue={inputFields[index].endDate ? moment(inputFields[index].endDate, 'MM-DD-YYYY HH:mm') : null}
                                            placeholder="End Date (MM-DD-YYYY)"
                                            showTime
                                            onChange={event => {handleInputChange(index, event, 'endDate')}} 
                                            className="start-date-picker" 
                                         />
                                        {eDateErr && eDateErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter end date</p>:null}
                                    </div> 





  






                                    <div className="col-md-6"  style={{marginTop:'30px'}}>

                                        <div className="page-rightside-action-column">

                                            {inputFields.length - index === 1?

                                            <button
                                                style={{background:'red', color:'#fff',  borderRadius:'10px', padding:'12px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                                type="button"
                                                className='addbtnitem-link text-anchor'
                                                disabled={index === 0}
                                                onClick={() => handleRemoveFields(index)}
                                            >
                                            <i className="icon-times" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Remove Session</span>
                                            </button>:null}

                                        </div>

                                    </div>
                                    


                                    <div className="col-md-6"  style={{marginTop:'30px'}}>

                                        <div className="page-rightside-action-column">

                                            {inputFields.length - index === 1?

                                            <button
                                                style={{background:'#4077cf', color:'#fff',  borderRadius:'10px', padding:'12px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                                type="button"
                                                className='addbtnitem-link text-anchor'
                                                onClick={() => handleAddFields(index)}
                                            >
                                            <i class="icon-add" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Add Session</span>
                                            </button>:null}

                                        </div>

                                    </div>
                                    



                    
                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        </form>

                        </Panel>  





                </div>
                </li>

            ))}

            </ul>
            </div>








</Panel>


                <div style={{marginTop:'30px', textAlign:'center'}}>
                    <button onClick={()=>{navigate("/sessions/"+wid)}} 
                    style={{backgroundColor:'#fff', 
                    width:'40%',
                    border:'2px solid #144A98', 
                    padding:'10px', 
                    paddingLeft:'50px', 
                    paddingRight:'50px',
                    margin:'10px',
                    borderRadius:'10px',
                    fontSize:'16px',
                    color:'#144A98',
                }}>Cancel</button>
                    <button onClick={WorkshopMultipleAdd} 
                    style={{backgroundColor:'#144A98', 
                    width:'40%',
                    border:'2px solid #144A98', 
                    padding:'10px', 
                    paddingLeft:'50px', 
                    paddingRight:'50px',
                    margin:'10px',
                    borderRadius:'10px',
                    fontSize:'16px',
                    color:'#fff',
                }}>Create Session</button>
            </div>




                </div>
            </aside>
        </div>
      
  );
};

export default WorkshopSessionCreate;